































































































































































































































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "../../../plugins";
import { uuid } from "../../../utils/uuid";
import { CreateAppData } from "../transform";

const GrayForm = {
  name: "",
  description: "",
  serviceName: "",
  releaseApp: "",
  releaseType: "",
  spec: {
    hosts: [""],
    http: [
      {
        route: [
          {
            destination: {
              host: "",
              port: { number: "" },
              subset: ""
            },
            weight: 100
          },
          {
            destination: {
              host: "",
              port: { number: "" },
              subset: ""
            },
            weight: 0
          }
        ],
        timeout: null
      }
    ]
  }
};
export default Vue.extend({
  name: "CreateGrayScaleForm",
  props: {
    data: { type: Object },
    type: { type: String },
    projectId: { type: String },
    appCode: { type: String }
  },
  data() {
    // const versionVeditor = (rule: any, value: string, callback: any) => {
    //   if (value !== this.data.metadata.labels.version) {
    //     callback();
    //   } else {
    //     callback("两个版本相同");
    //   }
    // };
    const validateHost = (rule: any, value: string, callback: any) => {
      axios
        .get(
          `/grayrelease/${this.projectId}/release/exists?serviceName=${value}`
        )
        .then(res => {
          if (res.data.data) {
            callback();
          } else {
            this.$message.error("已经存在灰度发布任务，请先下线任务");
            callback("host错误");
          }
        })
        .catch(() => {
          callback("host错误");
        });
    };
    return {
      // BLUEGREEN 蓝绿
      // CANCRY 金丝雀
      dialog: false,
      loading: false,
      isEdit: false,
      // 创建灰度发布时，需要同时维护 2个表单
      // 同时为了方便填写规则校验
      // 将可填写参数单独抽离为一个新表单
      ruleForm: {
        name: "",
        newName: "",
        type: "",
        host: "",
        description: "",
        // version: "",
        replicas: 1
      },
      rules: {
        name: [
          {
            required: true,
            trigger: "change",
            pattern: /^[a-z0-9-]+$/,
            max: 253
          }
        ],
        // version: [
        //   {
        //     required: true,
        //     trigger: "change",
        //     pattern: /^[a-z0-9]+$/,
        //     max: 16
        //   },
        //   {
        //     validator: versionVeditor,
        //     trigger: "change"
        //   }
        // ],
        replicas: [{ required: true, trigger: "change" }],
        host: [{ required: true, trigger: "change", validator: validateHost }]
      },
      // 灰度发布表单
      resData: JSON.parse(JSON.stringify(GrayForm)) as typeof GrayForm,
      // 新组建表单
      comData: (null as any) as CreateAppData,
      serviceOptions: [],
      configOptions: [],
      keyOptions: [],
      editIndex: (undefined as any) as number
    };
  },
  mounted() {
    const app = document.querySelector("#prj-app");
    if (app) {
      app.appendChild(this.$el);
    }
    this.getService();
    this.getConfig();
    this.getKey();
  },
  beforeDestroy() {
    const app = document.querySelector("#prj-app");
    if (app) {
      app.removeChild(this.$el);
    }
  },
  methods: {
    // 获取密钥
    getKey() {
      return axios.get(`/secret/list?projectId=${this.projectId}`).then(res => {
        this.keyOptions = res.data.data;
      });
    },
    // 获取配置
    getConfig() {
      return axios.get(`/configmap/${this.projectId}`).then(res => {
        this.configOptions = res.data.data.items;
      });
    },
    getService() {
      axios
        .get(`/service/${this.projectId}?page=1&listId=${uuid()}&size=9999`)
        .then(res => {
          this.serviceOptions = res.data.data.list;
        });
    },
    showSeleckImage(data?: any) {
      if (data?.index > -1) {
        // 判断编辑状态 设置编辑的数组子下标
        (this.$refs.selectImage as any).show(
          data?.data,
          // 编辑 image时 将 imagePullSecrets 传回编辑页面
          this.comData.spec.template.spec.imagePullSecrets[data?.index]
        );

        this.editIndex = data?.index;
      } else {
        (this.$refs.selectImage as any).show();
      }
    },
    addImage({ data, info, secret }: any) {
      const newData = JSON.parse(data);
      newData.info = JSON.parse(info);
      if (this.editIndex !== undefined) {
        this.comData.spec.template.spec.containers.splice(
          this.editIndex,
          1,
          newData
        );

        this.comData.spec.template.spec.imagePullSecrets.splice(
          this.editIndex,
          1,
          secret
        );
        this.editIndex = (undefined as any) as number;
      } else {
        if (!this.comData.spec.template.spec.containers) {
          this.comData.spec.template.spec.containers = [];
        }
        this.comData.spec.template.spec.containers.push(newData);
        if (!this.comData.spec.template.spec.imagePullSecrets) {
          this.comData.spec.template.spec.imagePullSecrets = [];
        }
        this.comData.spec.template.spec.imagePullSecrets.push(secret);
      }
    },
    show(type: string, data?: any) {
      this.ruleForm.type = type;
      this.dialog = true;

      if (data) {
        //
        this.isEdit = true;
      } else {
        if (type === "BLUEGREEN") {
          this.resData.spec.http[0].route[0].weight = 0;
          this.resData.spec.http[0].route[1].weight = 100;
        } else {
          this.resData.spec.http[0].route[0].weight = 50;
          this.resData.spec.http[0].route[1].weight = 50;
        }
        this.setData();
      }
    },
    remove(index: number) {
      this.resData.spec.http[0].route[index].weight = 0;
      // (index + 1) % 2 判断 0 或 1
      this.resData.spec.http[0].route[(index + 1) % 2].weight = 100;
    },
    apply(index: number) {
      this.resData.spec.http[0].route[index].weight = 100;
      // (index + 1) % 2 判断 0 或 1
      this.resData.spec.http[0].route[(index + 1) % 2].weight = 0;
    },
    weightChange(value: number, index: number) {
      this.resData.spec.http[0].route[(index + 1) % 2].weight = 100 - value;
    },
    quit() {
      //
      (this.$refs.ruleForm as Form).resetFields();
      this.isEdit = false;
      this.resData = JSON.parse(JSON.stringify(GrayForm));
      this.comData = (null as any) as CreateAppData;
      this.$nextTick(() => {
        this.dialog = false;
      });
    },
    submit() {
      //
      (this.$refs.ruleForm as Form).validate(valid => {
        if (valid) {
          this.loading = true;
          this.setData();
          this.createNewApp()
            .then(() => {
              return this.createGrayScale();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    setData() {
      // 灰度发布表单
      this.resData.name = this.ruleForm.name;
      this.resData.releaseType = this.ruleForm.type;
      this.resData.description = this.ruleForm.description;
      this.resData.releaseApp = this.data.metadata.labels.app;
      this.resData.spec.hosts = [this.ruleForm.host];
      const service: any = this.serviceOptions.find((item: any) => {
        return item.metadata.name === this.ruleForm.host;
      });
      // 服务判断
      if (service) {
        this.resData.spec.http[0].route[0].destination.port = {
          number: service.spec.ports[0].port
        };
        this.resData.spec.http[0].route[1].destination.port = {
          number: service.spec.ports[0].port
        };
      }

      this.resData.spec.http[0].route[0].destination.host = this.ruleForm.host;
      this.resData.spec.http[0].route[1].destination.host = this.ruleForm.host;
      this.resData.serviceName = this.ruleForm.host;
      this.resData.spec.http[0].route[0].destination.subset = this.data.metadata.name;
      this.resData.spec.http[0].route[1].destination.subset = this.ruleForm.newName;
      // 新建组件表单
      this.comData = JSON.parse(JSON.stringify(this.data));
      this.comData.createRelatedService = false;
      // this.comData.metadata.labels.version = this.ruleForm.version;
      this.comData.metadata.name = this.ruleForm.newName;
      this.comData.spec.replicas = this.ruleForm.replicas;
      // @ts-ignore
      if (this.comData.metadata.resourceVersion) {
        // @ts-ignore
        delete this.comData.metadata.resourceVersion;
      }
      // @ts-ignore
      if (this.comData.spec.template.metadata.resourceVersion) {
        // @ts-ignore
        delete this.comData.spec.template.metadata.resourceVersion;
      }
    },
    // 创建灰度发布之前根据 版本创建一个新的组件
    createNewApp() {
      let url = "";
      if (this.type === "无状态组件") {
        url = "/deployment/";
      } else {
        url = "/statefulset/";
      }
      return axios.post(`${url}${this.projectId}`, this.comData);
    },
    createGrayScale() {
      //
      return axios
        .post(`/grayrelease/${this.projectId}/release`, this.resData)
        .then(() => {
          this.$message.success("灰度发布创建成功");
          this.$emit("refush");
          this.quit();
        });
    }
  }
});
